<template>
  <AntModal
    :visible="modalVisible"
    width="800px"
    :bodyStyle="{ maxHeight: '70vh', overflowY: 'auto' }"
    title="Update section sortOrder"
    okText="Confirm"
    cancelText="Cancel"
    :confirmLoading="confirmLoading"
    centered
    @ok="handleConfirm"
    @cancel="handleCancel"
  >
    <div>
      <AntAlert
        message="Detected the following sections that need to update the sortOrder, please confirm the changes:"
        type="info"
        showIcon
        style="margin-bottom: 16px"
      />

      <div v-if="sectionsData && sectionsData.length">
        <h4>sortOrder change details:</h4>
        <AntTable
          :dataSource="sectionsData"
          :columns="columns"
          :pagination="false"
          size="small"
          bordered
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'originalSortOrder'">
              <span style="font-weight: bold; color: #ff4d4f;">
                {{ record.originalSortOrder }}
              </span>
            </template>
            <template v-else-if="column.dataIndex === 'sortOrder'">
              <span style="font-weight: bold; color: #52c41a;">
                {{ record.sortOrder }}
              </span>
            </template>
            <template v-else-if="column.dataIndex === 'titles'">
              <div>
                <div>{{ record.enTitle }}</div>
                <div>{{ record.cnTitle }}</div>
              </div>
            </template>
          </template>
        </AntTable>
      </div>

      <div v-else>
        <AntEmpty description="No data to update" />
      </div>
    </div>
  </AntModal>
</template>

<script>
import {
  ref,
  // reactive,
  onMounted,
  onUnmounted,
} from 'vue'

import {
  Modal as AntModal,
  Table as AntTable,
  Alert as AntAlert,
  Empty as AntEmpty,
  message as antMessage,
} from 'ant-design-vue'

import { batchWriteSections } from '@/api/apiDocV2'

export default {
  name: 'SortOrderUpdateModal',
  components: {
    AntModal,
    AntTable,
    AntAlert,
    AntEmpty,
  },
  setup() {
    const modalVisible = ref(false)
    const confirmLoading = ref(false)
    const sectionsData = ref([])

    const columns = [
      {
        title: 'Original sortOrder',
        dataIndex: 'originalSortOrder',
        key: 'originalSortOrder',
        width: 100,
        align: 'center',
      },
      {
        title: 'New sortOrder',
        dataIndex: 'sortOrder',
        key: 'sortOrder',
        width: 100,
        align: 'center',
      },
      {
        title: 'title',
        dataIndex: 'titles',
        key: 'titles',
      },
      {
        title: 'sectionId',
        dataIndex: 'sectionId',
        key: 'sectionId',
        width: 200,
        ellipsis: true,
      },
      {
        title: 'docId',
        dataIndex: 'docId',
        key: 'docId',
        width: 200,
        ellipsis: true,
      },
    ]

    // Modal 相關的狀態管理
    let modalData = null
    let modalCallback = null

    // 確認更新函數
    const confirmSortOrderUpdate = async () => {
      if (modalData && modalCallback) {
        try {
          const { data: updateSortOrderRes } = await batchWriteSections(modalData.map(({ originalSortOrder, ...rest }) => rest))
          console.log('transformToNested update sortOrder res', updateSortOrderRes)
          if (modalCallback) {
            modalCallback(updateSortOrderRes)
          }
        } catch (error) {
          console.error('batchWriteSections error:', error)
          throw error
        }
      }
      modalData = null
      modalCallback = null
    }

    // 取消更新函數
    const cancelSortOrderUpdate = () => {
      modalData = null
      modalCallback = null
    }

    const handleShowModal = (event) => {
      const { sectionsData: data, callback } = event.detail
      sectionsData.value = data
      modalData = data
      modalCallback = callback
      modalVisible.value = true
    }

    const handleConfirm = async () => {
      confirmLoading.value = true
      try {
        await confirmSortOrderUpdate()
        modalVisible.value = false
        antMessage.success('Sort order updated successfully')
      } catch (error) {
        console.error('Failed to update sort order:', error)
        antMessage.error('Failed to update sort order')
      } finally {
        confirmLoading.value = false
      }
    }

    const handleCancel = () => {
      cancelSortOrderUpdate()
      modalVisible.value = false
    }

    // 監聽 Modal 顯示事件
    onMounted(() => {
      window.addEventListener('showSortOrderUpdateModal', handleShowModal)
    })

    onUnmounted(() => {
      window.removeEventListener('showSortOrderUpdateModal', handleShowModal)
    })

    return {
      modalVisible,
      confirmLoading,
      sectionsData,
      columns,
      handleConfirm,
      handleCancel,
    }
  },
}
</script>

<style scoped>
.ant-table-tbody > tr > td {
  padding: 8px;
}
</style>
